module.exports = __webpack_public_path__ + "img/bg-modal.7de804e0.png";